import { defineStore } from 'pinia'

interface ScaleSettings {
  fontSize: number // base font size in pixels
  layoutSize?: number // base font size size for the layout
  layoutRatio?: number // layoutRatio is the modular scale for the layout
  gridRatio: number // gridRatio is essentially lineHeight
  ratio: number // represents the module scale
}
type MediaSnapPoint = number

interface ScaleRootState {
  active: boolean
  dialogActive: boolean

  row: Record<string, any>
  column: Record<string, any>
  wrap: Record<string, any>

  // fontSize: number // The base font size in pixels.
  // layoutSize: number // the base font size in pixels for the layout
  // gridRatio: number
  scale: ScaleSettings
  scaleOptions: Array<{ label: string, value: number }>

  // Css Dmo injection
  // classScaleLevels represents the number of scale levels to generate css classes for the font size
  classScaleLevels: number

  scales: TypeScales

}

export const useScaleStore = defineStore('scale', {
  state: (): ScaleRootState => ({

    // Whether to inject into the html tag or not.
    active: true,

    dialogActive: false,

    classScaleLevels: 10,

    // Layout
    // Defaults
    row: {
      wrap: 'full',
    },
    column: {
      wrap: 'full',
    },
    wrap: {
      // full: {
      //   width: '100%',
      //   maxWidth: '100%',
      //   margin: '0 auto',
      // },
      // tight: {
      //   width: '100%',
      //   maxWidth: 'var(--max-width)',
      //   margin: '0 auto',
      // },
      // normal: {
      //   width: '100%',
      //   maxWidth: 'var(--max-width)',
      //   margin: '0 auto',
      // },
      // wide: {
      //   width: '100%',
      //   maxWidth: 'var(--max-width-wide)',
      //   margin: '0 auto',
      // },
      // fullScreen: {
      //   width: '100%',
      //   maxWidth: '100%',
      //   margin: '0 auto',
      // },
    },

    scaleOptions: [{
      label: 'minor Second - 1.067',
      value: 1.067,
    }, {
      label: 'major Second - 1.125',
      value: 1.125,
    }, {
      label: 'minor Third - 1.2',
      value: 1.2,
    }, {
      label: 'major Third - 1.25',
      value: 1.25,
    }, {
      label: 'perfect Fourth - 1.333',
      value: 1.333,
    }, {
      label: 'augmented Fourth - 1.414',
      value: 1.414,
    }, {
      label: 'perfect Fifth - 1.5',
      value: 1.5,
    }, {
      label: 'minor Sixth - 1.6',
      value: 1.6,
    }, {
      label: 'golden Ratio - 1.618',
      value: 1.618,
    }, {
      label: 'major Sixth - 1.667',
      value: 1.667,
    }, {
      label: 'minor Seventh - 1.778',
      value: 1.778,
    }, {
      label: 'major Seventh - 1.875',
      value: 1.875,
    }],

    // SCALE Source of truth, DEFAULTs
    // This scale will apply to everything if no other scale is specified in the media object
    scale: {
      fontSize: 18,
      layoutSize: 16,
      layoutRatio: 1.2,
      gridRatio: 1.6,
      ratio: 1.20,
    },

    // Represents maximum values
    scales: {
      550: {
        fontSize: 17,
        gridRatio: 1.5,
        ratio: 1.2,
      },
      1024: {
        fontSize: 16,
        gridRatio: 1.6,
        ratio: 1.25,
      },
      1440: {
        fontSize: 17,
        gridRatio: 1.5,
        ratio: 1.20,
      },
    },
  }),

  actions: {
    initScales(scales: ScaleSettings[]) {
      this.scales = scales
    },
    initBaseScale(scale: ScaleSettings) {
      this.scale = scale
    },
  },

  getters: {

    getScale: state => state.scale,
    getfontSize: state => state.scale.fontSize,
    getLineHeight: state => state.scale.gridRatio,

    fs: state => (point: number) => {
      // return 1rem if point is 0
      if (point === 0)
        return 1

      // Calculate the font size in pixels based on point value.
      const wholePoint = Math.floor(point)
      const fractionalPoint = point - wholePoint

      let fontSizeInPx = state.scale.fontSize * state.scale.ratio ** wholePoint

      // If there is a fractional point, calculate the appropriate font size in pixels.
      if (fractionalPoint !== 0) {
        const nextSizeInPx = state.scale.fontSize * state.scale.ratio ** (wholePoint + 1)
        fontSizeInPx += fractionalPoint * (nextSizeInPx - fontSizeInPx)
      }

      // Convert font size to rem units and return.
      const fontSizeInRem = fontSizeInPx / state.scale.fontSize
      return `${fontSizeInRem}`
    },

    lr: state => (point: number, customScale?: number) => {
      const fs = state.scale.fontSize // this should be your dynamic base font size
      const gridRatio = state.scale.gridRatio // this should be your dynamic line height
      const ratio = customScale || state.scale.ratio // this should be your dynamic scale or the provided custom scale

      const fontSize = fs * ratio ** point

      // Calculate the line height in a way that it’s always a multiple of the grid (1.5)
      const lines = Math.ceil(fontSize / (fontSize * gridRatio))
      return lines * gridRatio
    },
  },
})
